import { DisplayConfiguration as ProtoDisplayConfiguration } from "@opstel/gen/knop/ui/v1/model/display_configuration_pb";
import { z } from "zod/v3";
import { createSchema, ZodOutputFor } from "../zod-utils";
import { PlainMessage } from "@bufbuild/protobuf";

export interface DisplayConfiguration {
  displayOrder: number;
  visibleByDefault: boolean;
}

export const displayConfigurationSchema = createSchema<
  DisplayConfiguration,
  PlainMessage<ProtoDisplayConfiguration>
>({
  displayOrder: z.number(),
  visibleByDefault: z.boolean(),
}) satisfies ZodOutputFor<DisplayConfiguration>;
